import Vue from "vue";
import { Component } from "vue-property-decorator";

import moment from "moment";
import ScrollSync from "vue-scroll-sync";
import { IAppointment, AppointmentStatus, IAppointmentSlot, IAppointmentSecurityDay, AppointmentType, ExpeditionType } from "@/models";

@Component({
    name: "security-day",
    components: {
        "scroll-sync": ScrollSync,
    },
})

export default class SecurityDay extends Vue {
    public readonly multiAppointmentsModal: string = "multiAppointmentsModal";

    public multiAppointments: IAppointment[] = [];
    public selectedType: AppointmentType = null;

    public constructor() {
        super();
    }

    // LOGIC

    public get securityDay(): IAppointmentSecurityDay {
        return this.$store.getters["security/getSecurityDay"]();
    }

    public setSelectedAppointment(appointment: IAppointment): void {
        this.$store.commit("security/SET_SELECTED_APPOINTMENT", appointment);

        this.$router.push({ name: "securityAppointmentDetail" });
    }

    public lookupSlot(slotId: number): boolean {
        slotId += 21; // += 21 car 11 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        return this.securityDay.appointmentsSlots.some(x => x.slotId === slotId);
    }

    public lookupExpedition(slotId: number): boolean {
        slotId += 21;

        return this.securityDay.appointmentsSlots.find(x => x.slotId === slotId).expeditions.length !== 0;
    }

    public lookupReception(slotId: number): boolean {
        slotId += 21;

        return this.securityDay.appointmentsSlots.find(x => x.slotId === slotId).receptions.length !== 0;
    }

    public getTrucks(slotId: number, type: AppointmentType): IAppointment[] {
        slotId += 21;

        const vm = this.securityDay.appointmentsSlots.find(x => x.slotId === slotId);

        if (type === AppointmentType.Expedition) {
            return vm.expeditions;
        }
        else {
            return vm.receptions;
        }
    }

    public isManyAppointments(slotId: number, type: AppointmentType): boolean {
        return this.getTrucks(slotId, type).length > 1;
    }

    public getTruck(slotId: number, type: AppointmentType): IAppointment {
        slotId += 21;

        const vm = this.securityDay.appointmentsSlots.find(x => x.slotId === slotId);

        if (type === AppointmentType.Expedition) {
            return vm.expeditions[0];
        }
        else {
            return vm.receptions[0];
        }
    }

    public getSlot(slotId: number): IAppointmentSlot {
        slotId += 21;

        return this.securityDay.appointmentsSlots.find(x => x.slotId === slotId);
    }

    public setMultiAppointments(slotId: number, type: AppointmentType): void {
        this.multiAppointments = this.getTrucks(slotId, type);
        this.selectedType = type;
        this.$modal.show(this.multiAppointmentsModal);
    }

    // DESIGN AND NAVIGATION
    public getTimeCellDesign(index): string {
        if (moment(this.securityDay.day).isSame(moment().hour(0).minute(0).second(0), "day")) {
            const timeCell = moment().hour(5).minute(0).add(15 * index, "m"); // start time at 5:30

            if (moment().diff(timeCell) > 0) {
                return "passed";
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }

    public styleForState(item: IAppointment): string {
        if (item.status === AppointmentStatus.Waiting || item.status === AppointmentStatus.Unexpected) {
            return "not-arrived";
        } else if (item.status === AppointmentStatus.Cancel) {
            return "cancel";
        } else {
            return "arrived";
        }
    }

    public displayLabelExpedition(slotId: number, type: AppointmentType): string {
        const truck = this.getTruck(slotId, type);

        return this.getValueForExpeditionTruck(truck);
    }

    public displayLabelReception(slotId: number, type: AppointmentType): string {
        const truck = this.getTruck(slotId, type);

        return truck.transporterName ? truck.transporterName : "DS";
    }

    public getValueForExpeditionTruck(truck: IAppointment) {
        switch (truck.expeditionType) {
            case ExpeditionType.Shuttle:
                return truck.transporterName;
            case ExpeditionType.Container:
                return "DS";
            case ExpeditionType.Other:
                return truck.comment;
            default:
                return "";
        }
    }
}
